import { useQuery } from "@tanstack/react-query";
import { httpClient } from "@/shared/api/http-client";
import type { SubscriptionTierConfig, SubscriptionTiersResponse } from "./types";
import { SUBSCRIPTION_TIERS_QUERY_KEY } from "./constants";

/**
 * `GET /api/admin/subscription-tiers` (API-CAP-1) — all tiers, active and
 * inactive, weight-ordered. Hand-written `httpClient` call — see CLAUDE.md → TD-07.
 */
async function fetchTiers(): Promise<readonly SubscriptionTierConfig[]> {
  const res = await httpClient<SubscriptionTiersResponse>("/api/admin/subscription-tiers");
  return res.items;
}

export function useSubscriptionTiersList() {
  return useQuery({
    queryKey: SUBSCRIPTION_TIERS_QUERY_KEY,
    queryFn: fetchTiers,
    staleTime: 60_000,
  });
}
